import {
  getProductFieldDisplayName,
  getProductFieldTextDisplayName,
} from '../../services/ProductHelperService';

function createAdditionalField(id, name, displayName, dynamics = false, type = 'url') {
  return { id, name, displayName, type, dynamics };
}


export function buildMappingProductFields(project, isXmlFormat = false) {
  const raw = project?.feed?.feed_fields;
  if (!raw) return [];

  let fields;
  try {
    fields = JSON.parse(raw);
  } catch {
    return [];
  }

  const array = Object.keys(fields)
    .filter((f) => !f.includes('_changed') && f !== 'fresh')
    .map((f) => ({
      id: f,
      name: getProductFieldDisplayName(f, fields[f]),
      displayName: getProductFieldTextDisplayName(f, fields[f], true),
      type: fields[f],
    }));

  array.push(createAdditionalField('new_image_link', '[new] First image', '[new] First image'));
  if (!isXmlFormat) {
    array.push(
      createAdditionalField('new_additional_image_link', '[new] Other images', '[new] Other images'),
    );
  }
  array.push(createAdditionalField('new_image_link_[N]', '[new] Image', '[new] Image 1', true));
  return array;
}
